import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import CarrierDetails from './carrier-details';

import messages from './messages';
import style from './style.module.less';

const ShipmentDetails = ({ shipment }) => {
  const { shipmentDetail, carriers } = shipment;
  return (
    <>
      <div className={classNames(style['header-label'], style.underline)}>
        <FormattedMessage {...messages.shippingFromHeaderLabel} values={{ shipmentDetailName: shipmentDetail.name }} />
      </div>
      <div className={style['shipment-details']}>
        <div className={style.header}>
          <FormattedMessage {...messages.shipmentDetailsHeaderLabel} />
        </div>
        {carriers.map((carrier, index) => (
          <CarrierDetails key={index} carrier={carrier} />
        ))}
      </div>
    </>
  );
};

ShipmentDetails.propTypes = {
  shipment: PropTypes.shape({
    shipmentDetail: PropTypes.shape({
      name: PropTypes.string,
    }),
    carriers: PropTypes.array,
  }).isRequired,
};

export default ShipmentDetails;
